import {
  DELETE_PAYMENT_PLAN_INSTALMENT_API_SUCCESS,
  PaymentPlanActionTypes,
} from '../../payment-plan/payment-plan.actions';

export const paymentPlanEntityReducer = (state: any = {}, action: PaymentPlanActionTypes) => {
  switch (action.type) {
    case DELETE_PAYMENT_PLAN_INSTALMENT_API_SUCCESS: {
      const { paymentPlanId, instalmentId } = action.payload;
      const paymentPlan = state[paymentPlanId];
      if (!paymentPlan) return state;
      return {
        ...state,
        [paymentPlanId]: {
          ...paymentPlan,
          instalments: (paymentPlan.instalments || []).filter((id: string) => id !== instalmentId),
        },
      };
    }
    default:
      return state;
  }
};

export const paymentPlanInstalmentEntityReducer = (state: any = {}, action: PaymentPlanActionTypes) => {
  switch (action.type) {
    case DELETE_PAYMENT_PLAN_INSTALMENT_API_SUCCESS: {
      const { instalmentId } = action.payload;
      if (!state[instalmentId]) return state;
      const { [instalmentId]: _removed, ...rest } = state;
      return rest;
    }
    default:
      return state;
  }
};
